<template>
  <div class="routes">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[{ text: $t('routes.routes'), name: 'company_routes' }, { text: $t('routes.routeEditor.title') }]"
        />
      </template>
    </SectionHeader>
    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap route-editor">
          <header class="content-header content-header--with-select">
            <div class="header-meta">
              <ProjectSelect v-model="selectedProjectUuid" :companyUuid="companyUser.company_uuid" />
              <WeekdaySelect v-model="selectedWeekday" />
            </div>
          </header>
          <div class="content-body">
            <LoadingSpinner v-if="loading" />
            <div v-else-if="routeEditorStops.length == 0" class="alert alert-danger">
              {{ $t('routes.routeEditor.noData') }}
            </div>
            <DraggableTable v-else :items="routeEditorStops" @dragged-and-dropped="updateRouteEditor" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumbs from '@/components/BreadCrumbs'
import LoadingSpinner from '@/components/LoadingSpinner'
import DraggableTable from '@/components/RouteEditor/DraggableTable'
import ProjectSelect from '@/components/RouteEditor/ProjectSelect.vue'
import WeekdaySelect from '@/components/RouteEditor/WeekdaySelect.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import routeEditorsApi from '@/api/routeEditors'
import { mapSettings } from '@/utils/settings'

export default {
  name: 'company_route_editor',
  inject: ['companyUser'],
  components: {
    BreadCrumbs,
    DraggableTable,
    CompanyNav,
    LoadingSpinner,
    ProjectSelect,
    SectionHeader,
    WeekdaySelect,
  },
  data() {
    return {
      loading: true,
      routeEditorStops: [],
      selectedProjectUuid: null,
      selectedWeekday: 'monday',
    }
  },
  computed: {
    ...mapSettings(['projectUuids']),
  },
  watch: {
    async selectedProjectUuid() {
      await this.getRouteEditorData()
    },
    async selectedWeekday() {
      await this.getRouteEditorData()
    },
  },
  methods: {
    async getRouteEditorData() {
      this.loading = true
      const response = await routeEditorsApi.get(this.selectedProjectUuid, this.selectedWeekday)
      if (response) this.routeEditorStops = response
      this.loading = false
    },
    async updateRouteEditor(movedElement) {
      const response = await routeEditorsApi.update(this.selectedProjectUuid, this.selectedWeekday, movedElement)
      if (response) this.routeEditorStops = response
    },
  },
}
</script>

<style lang="scss">
.routes {
  height: calc(100vh - var(--nav-height));

  .body-content {
    height: calc(100% - var(--section-header-height));
    display: flex;
  }
}
.route-editor {
  height: 100%;
  .content-header--with-select {
    height: 80px;
  }
  .header-meta {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;

    .v-select {
      flex: 0 1 100%;
    }
  }
  .content-body {
    height: calc(100% - 80px);
  }
}
</style>
